export const newAttributes = [
  "اخلاق و رفتار مناسب",
  "کیفیت انجام کار",
  "مشاوره دقیق و کارشناسانه",
  "توجه به جزئیات ریز و مهم",
  "اخلاق و رفتار مناسب",
  "کیفیت انجام کار",
  "مشاوره دقیق و کارشناسانه",
  "توجه به جزئیات ریز و مهم",
];

export const assessmentParametersLabelConstant: Record<string, string> = {
  accuracyAndQuality: "دقت و کیفیت",
  bePatientAndResponsive: "صبوری در پاسخگویی",
  creativity: "خلاقیت",
  fairPrice: "قیمت منصفانه",
  masteryInCounseling: "تسلط در مشاوره",
  moral: "خوش اخلاقی",
  timelyDelivery: "خوش قولی",
  trustworthy: "قابل اعتماد"
}